import { render } from "./TopNewsNormal.vue?vue&type=template&id=59610eb6&scoped=true&ts=true"
import script from "./TopNewsNormal.vue?vue&type=script&lang=ts"
export * from "./TopNewsNormal.vue?vue&type=script&lang=ts"

import "./TopNewsNormal.vue?vue&type=style&index=0&id=59610eb6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59610eb6"]])

export default __exports__